/// Reference Constants
/// NOTES: Please keep in sync with IGS.Solar.Core\Constants\Reference.cs
    export class Reference {

        //Event Outcomes
        public static readonly notStartedEventOutcomeCode = "NS";
        public static readonly inProgressEventOutcomeCode = "IP";
        public static readonly successEventOutcomeCode = "SUCC";
        public static readonly failureEventOutcomeCode = "FAIL";
        public static readonly errorEventOutcomeCode = "ERR";

        //Event Codes
        public static readonly creditCheckEventCode = "CreditCheck";

        public static readonly OpportunityEvent = Object.freeze({
            associatedRegionEventCode: "AssociatedRegion",
            associatedEpcCalculationEventCode: "AssociatedEpcCalculation",
            preliminarySystemDetailsEventCode: "SubmittedPreliminarySystemDetails"
        })

        public static readonly paymentCapturePerformedEventCode = "PaymentCapture";
        public static readonly paymentInformationRecEventCode = "PaymentInformationReceived";
        public static readonly creditAuthSignedEventCode = "CreditAuthSigned";
        public static readonly electronicConsentSignedEventCode = "ElectronicConsentSigned";
        public static readonly contractSignedEventCode = "ContractSigned";
        public static readonly scheduleA1EventCode = "ScheduleA1";
        public static readonly utilityBillUploadEventCode = "UtilityBillUpload";
        public static readonly permissionToOperateEventCode = "PTO";
        public static readonly systemMonitoringIdSetEventCode = "SystemMon";
        public static readonly salesforceIdSetEventCode = "SalesforceId";
        public static readonly hasNonTerminalContractEnvelopesEventCode = "HasNonTerminalContractEnvelopes";
        public static readonly hasNonTerminalEnvelopesEventCode = "HasNonTerminalEnvelopes";
        public static readonly titleValidationEventCode = "TitleValidation";
        public static readonly amendRateEscalator = "AmendRateEscalator";
        public static readonly systemDataReconciled = "SystemDataReconciled";
        public static readonly submittedInstalledSystemDetails = "SubmittedInstalledSystemDetails";
        public static readonly milestone2Completed = "Milestone2Completed";

        //Document Types
        public static readonly asbuiltDescriptionDocumentTypeCode = "ASBUILT_DESCRIPTION";
        public static readonly contractAffidavitDocumentTypeCode = "CONTRACTOR_AFFIDAVIT";
        public static readonly contractorFinalInvoiceDocumentTypeCode = "INVOICE_FINAL";
        public static readonly contractorInitialInvoiceDocumentTypeCode = "INVOICE_INIT";
        public static readonly creditAuthDocumentTypeCode = "CREDIT_AUTH";
        public static readonly customerAcknowledgementDocumentTypeCode = "CUSTOMER_ACK";
        public static readonly designModificationDocumentTypeName = "Design Modifications";
        public static readonly designModificationsDocumentTypeCode = "MODIFICATIONS";
        public static readonly electronicConsentDocumentTypeCode = "ELEC_CONSENT";
        public static readonly epcCalculationDocumentTypeCode = "EPC";
        public static readonly installedSystemPhotosDocumentTypeCode = "PHOTOS";
        public static readonly contractDocumentTypeCode = "CONTRACT";
        public static readonly scheduleA1DocumentTypeCode = "SA1";
        public static readonly scheduleA1DocumentTypeName = "Schedule A-1";
        public static readonly titleValidationDocumentTypeCode = "TITLEVALIDATION";
        public static readonly utilityBillDocumentTypeCode = "UTILITY_BILL";

        //Docusign Envelope Status Codes
        public static readonly envelopeSentCode = "SENT";
        public static readonly envelopeCancelCode = "CANCELED";
        public static readonly envelopeCompletedCode = "COMPLETED";
        public static readonly envelopeDeclinedCode = "DECLINED";
        public static readonly envelopeDoNothingCode = "DONOTHING";
        public static readonly envelopeViewingCompleteCode = "VIEWING_COMPLETE";

        // Credit Check Flows
        public static readonly agentCreditCheckWorkflowCode = "AGENT";
        public static readonly customerCreditCheckWorkflowCode = "CUSTOMER";

        // Credit Check Results
        public static readonly creditCheckPassResultCode = "PASS";
        public static readonly creditCheckFailResultCode = "FAIL";
        public static readonly creditCheckNoHitResultCode = "NOHIT";
        public static readonly creditCheckHoldResultCode = "HOLD";
        public static readonly creditCheckErrorResultCode = "ERROR";

        // System Component Types
        public static readonly moduleComponentTypeName = "Module";
        public static readonly inverterComponentTypeName = "Inverter";
        public static readonly revenueGradeMeterComponentTypeName = "Revenue Grade Meter";
        public static readonly rackingComponentTypeName = "Rack";

        // Tranche Type Codes
        public static readonly fccTrancheType = "FCC";
        public static readonly aatTrancheType = "AAT";
        public static readonly debtTrancheType = "DEBT";

        public static readonly criticalSeverityCode = "CRIT";
        public static readonly warningSeverityCode = "WARN";
        public static readonly infoSeverityCode = "INFO";
        public static readonly successSeverityCode = "SUCC";

        public static readonly severityMap = {
            "CRIT": 0,
            "WARN": 1,
            "INFO": 2,
            "SUCC": 3,
        };

        // Process Review Types
        public static readonly milestoneProcessReviewType = "MILESTONE";
        public static readonly additionalInvoiceProcessReviewType = "ADDITIONALINVOICE";
        public static readonly refundProcessReviewType = "REFUND";

        // Milestone Codes
        public static readonly CustomerComplete = "CustComplete";
        public static readonly InstallComplete = "InstallComplete";
        public static readonly NoticeToProceed = "NoticeToProceed";

        //Calculation Types
        public static readonly ReconcileCalculationType = "Reconcile";
        public static readonly AssociateCalculationType = "Associate";
        public static readonly SandboxCalculationType = "Sandbox";
        public static readonly AmendmentCalculationType = "Amendment";

        // Genesys
        public static readonly Genesys_Provider = "OKTA";
        public static readonly Genesys_Org = "IGS";
        public static readonly Genesys_ClientId = "a003ae43-60d7-4416-a77d-bf6c5b4a9432";
        public static readonly Genesys_Target = "9fe97059-b478-4ccf-88f6-7523832da8f4";
        public static readonly Genesys_BaseUrl = "https://login.usw2.pure.cloud/oauth/authorize";

        // LPG Statuses
        public static readonly LeaseProdGuaranteeCompleteStatus = "Complete";
        public static readonly LeaseProdGuaranteeFailureStatus = "LPG Failure";
        public static readonly LeaseProdGuaranteeInReviewStatus = "In Review";

        //LPG Dispositions
        public static readonly LeaseProdGuaranteeApprovedDisposition = "Approved";
        public static readonly LeaseProdGuaranteeNotApprovedDisposition = "Not Approved";
        public static readonly LeaseProdGuaranteeExcludedDisposition = "Excluded";
        public static readonly LeaseProdGuaranteeNoneDisposition = "None";
        public static readonly LeaseProdGuaranteeOnHoldDisposition = "On Hold";
    }
